module.exports = __webpack_public_path__ + "static/media/byxa-min.350258b6.png";